import dayjs from "dayjs";

/** Format a stored date answer, or null when it is empty or unparseable. */
export function formatEntryDate(value: string | null | undefined, format: string): string | null {
    if (!value) return null;
    const date = dayjs(value);
    return date.isValid() ? date.format(format) : null;
}
